import React from "react";
import { Link } from "react-router-dom";
import { Card, Dropdown, Row } from "react-bootstrap";
import ReactApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const UserPost = (props: any) => {
  let data: any = props.data;
  // Copy before sorting: Array.prototype.sort mutates, and this array is the
  // parent's state, so the chart was quietly reordering its own source.
  const top10 = [...data].sort((a: any, b: any) => b.postCount - a.postCount).slice(0, 10);
  // Typed any[], not []: the empty-tuple annotations these carried only ever
  // compiled because `any` was flowing through the sort above them.
  let value: any[] = top10.map((item: any) => item.postCount);
  let user: any[] = top10.map((item: any) => item.email);
  // pass chart data dynamically
  const apexOpts: ApexOptions = {
    chart: {
      height: 332,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    colors: ["#16a7e9"],
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: "Posts",
        data: value,  // Dynamically map the totalPosts
      },
    ],
    xaxis: {
      categories: user, // Dynamically map the admin names
      axisBorder: {
        show: false,
      },
      labels: {
        formatter: function (val: any) {
          return val;
        },
      },
    },
    grid: {
      strokeDashArray: 5,
    },
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="header-title">
          Admin Posts
          <span className="text-muted fs-13 ms-1">
            · incidents created in the selected range
          </span>
        </h4>
        {/* <Dropdown>
          <Dropdown.Toggle as="a" className="arrow-none card-drop">
            <i className="ri-more-2-fill" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Refresh Report</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </Card.Header>

      <Card.Body className="pt-0">
        <Row>
          <ReactApexCharts
            className="apex-charts"
            options={apexOpts}
            height={350}
            series={apexOpts.series}
            type="bar"
          />
          <div className="table-responsive mt-3">
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Admin</th>
                  <th>Posts</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>
                      <Link to="#" className="text-muted">
                        {item.email} : {item.firstName} {item.lastName}
                      </Link>
                    </td>
                    <td>{item.postCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default UserPost;
